// NOTE: I don't like this either but this is a last minute request
// This will need to be updated if more order forms are added later
document.addEventListener('DOMContentLoaded', function() {
    handleNavCart()
})

document.addEventListener('vueFormsDomainCartUpdated', function(event) {
    handleNavCart()
})

function handleNavCart() {
    const navCartItem = document.querySelector('nav .nav-cart')
    const cartIcon = `<i class="fa fa-shopping-cart" aria-hidden="true"></i>`
    const domainRegistrationPageLocalStorageKey = 'vue-forms-domain-registration-form-url'

    // Store the domain registration page URL for later use
    let domainRegistrationPage = window?.corptoolsConfig?.links?.cartPage?.url
    if (domainRegistrationPage) {
        localStorage.setItem(domainRegistrationPageLocalStorageKey, domainRegistrationPage)
    }

    if (navCartItem) {
        navCartItem.style.display = 'none'

        // Likely not on a Vue forms page, try to pull from localStorage
        if (!domainRegistrationPage) {
            domainRegistrationPage = localStorage.getItem(domainRegistrationPageLocalStorageKey)
        }

        // Set the icon and URL, show the cart if there are cart items
        const navCartItemLink = navCartItem.querySelector('a')
        if (navCartItemLink && domainRegistrationPage) {
            navCartItemLink.innerHTML = cartIcon
            navCartItemLink.href = domainRegistrationPage

            if (hasDomainsAddedToCart()) {
                navCartItem.style.display = 'inline-block'
            }
        }
    }
}

function hasDomainsAddedToCart() {
    if (localStorage.key('vuex-domains')) {
        const data = JSON.parse(localStorage.getItem('vuex-domains'))
        if (data?.domains?.cartDomains && Object.keys(data?.domains?.cartDomains).length) {
            return true
        }
    }

    return false
}
